module.exports = __webpack_public_path__ + "static/img/SC6.09b5a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC6.jpg
// module id = ZwXR
// module chunks = 0